var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconImageEffects = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(1.083 7.013)" },
                    React.createElement("path", { d: "M9.4,2.4L8.1,4H6.6" })),
                React.createElement("path", { d: "M26.5,29.4" }),
                React.createElement("path", { d: "M21,27.2H4.9c-1.2,0-2.2-1-2.2-2.2V13.1c0-1.2,1-2.2,2.2-2.2h3.3 M18.2,21c-1.4,2-4,2.5-6,1.1\n\t\ts-2.5-4-1.1-6c0.3-0.4,0.7-0.8,1.1-1.1" }),
                React.createElement("path", { d: "M21.6,1.8L23.7,6l4.6,0.7L25,9.9l0.8,4.6l-4.1-2.2l-4.1,2.2l0.8-4.6L15,6.6L19.6,6\n\t\tL21.6,1.8z" }),
                React.createElement("path", { d: "M19.7,27.2h3.7c1.2,0,2.2-1,2.2-2.2v-3.7" })))));
});
export default IconImageEffects;
//# sourceMappingURL=IconImageEffects.js.map